import React from 'react';
import styles from './ConfirmSummary.module.scss';

interface SummaryField {
  label: string;
  value: React.ReactNode;
}

interface SummarySection {
  title: string;
  fields: SummaryField[];
}

interface ConfirmSummaryProps {
  sections: SummarySection[];
}

export default function ConfirmSummary({ sections }: ConfirmSummaryProps) {
  return (
    <div className={styles.summary}>
      {sections.map((section, i) => (
        <React.Fragment key={i}>
          <div className={styles.title} style={i > 0 ? { marginTop: 16 } : undefined}>
            {section.title}
          </div>
          <div className={styles.grid}>
            {section.fields.map((field, j) => (
              <div key={j} className={styles.field}>
                <div className={styles.label}>{field.label}</div>
                <div className={styles.value}>{field.value || '\u2014'}</div>
              </div>
            ))}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
